/** Коды поля error (см. php/api_errors.php, TheatresApiError). */
export const API_ERROR = {
    OK: 0,
    VALIDATION: 1,
    SERVER: 2,
    AUTH: 3,
    FORBIDDEN: 4,
};

export const apiErrorCode = (data) =>
    data?.error_code ?? (Number(data?.error) === API_ERROR.OK ? "ok" : "unknown");

export const isApiError = (data, code) => Number(data?.error) === code;

export const getApiErrorMessage = (data) =>
    (data && data.error_text) || "";

/** Парсит тело ответа, если axios не распознал JSON (нет Content-Type). */
export function parseApiResponse(data) {
    if (typeof data !== "string") {
        return data;
    }

    const trimmed = data.trim();

    if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) {
        return data;
    }

    try {
        return JSON.parse(trimmed);
    } catch {
        return data;
    }
}

/** Нормализует params из API в массив (на случай объекта с числовыми ключами). */
export function normalizeApiParams(params) {
    if (typeof params === "string") {
        try {
            params = JSON.parse(params);
        } catch {
            return [];
        }
    }

    if (Array.isArray(params)) {
        return params;
    }

    if (params && typeof params === "object") {
        return Object.values(params);
    }

    return [];
}
